import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Layout } from '../Layout';

interface ILayoutWithHeaderProps {
  title: string;
}

export function LayoutWithHeader({ title, children }: React.PropsWithChildren<ILayoutWithHeaderProps>) {
  return (
    <Layout>
      <div className={styles['header']}>
        <ArticleHeading1 as="h2" fontWeight="bold">
          {title}
        </ArticleHeading1>
      </div>
      {children}
    </Layout>
  );
}
